module.exports = __webpack_public_path__ + "static/media/as.04e53de7.webp";